// Manuales.js
import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ConvocatoriaCardsGrid from "../components/ConvocatoriaCardsGrid";
import { fetchManuales } from "../utils/contentfulRequests";

const Manuales = () => {
  const [manuales, setManuales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchManuales().then((data) => {
      setManuales(data);
      setLoading(false);
    });
  }, []);

  const filtered = manuales.filter((m) =>
    m.titulo.toLowerCase().includes(search.toLowerCase()) ||
    (m.descripcion && m.descripcion.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h3" sx={{ mb: 3, textAlign: "center" }}>
        Manuales
      </Typography>
  <Box sx={{ maxWidth: 600, width: '100%', mx: "auto", mb: 4 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por título o descripción..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <ConvocatoriaCardsGrid items={filtered} tipo="manual" />
      )}
    </Box>
  );
};

export default Manuales;